import React from "react";
import PropTypes from "prop-types";
import { Flex, Form, Provider } from "@fluentui/react-northstar";
import ForgottenPasswordEnterTextStep from "../../organisms/ForgottenPasswordEnterTextStep";
import ForgottenPasswordEnterCodeStep from "../../organisms/ForgottenPasswordEnterCodeStep";
import ForgottenPasswordEnterPasswordStep from "../../organisms/ForgottenPasswordEnterPasswordStep";
import Constants from "../../../constants/text-constants";
import ForgottenPasswordFormStates from "../../../constants/forgotten-password-states";
import ForgotPasswordErrorDialog from "../../atoms/ForgotPasswordErrorDialog";

const ForgottenPasswordPageTemplate = (props) => {
  const {
    currentStep,
    gotoNextStep,
    handleValueChange,
    resetCodeInputs,
    resetCode,
    username,
    gotoSignIn,
    email,
    password,
    loading,
    showErrorDialog,
    onErrorConfirm,
  } = props;

  const renderStep = () => {
    switch (currentStep) {
      case ForgottenPasswordFormStates.USERNAME:
        return (
          <ForgottenPasswordEnterTextStep
            nextClicked={gotoNextStep}
            gotoSignIn={gotoSignIn}
            handleValueChange={handleValueChange}
            subtitle={Constants.FORGOT_YOUR_PASSWORD_ENTER_USERNAME}
            testId="forgottenPasswordUsernameContainer"
            placeholder={Constants.USERNAME}
            value={username.value}
            valid={username.valid}
            id="username"
          />
        );
      case ForgottenPasswordFormStates.EMAIL:
        return (
          <ForgottenPasswordEnterTextStep
            nextClicked={gotoNextStep}
            gotoSignIn={gotoSignIn}
            handleValueChange={handleValueChange}
            subtitle={Constants.FORGOT_YOUR_PASSWORD_ENTER_EMAIL}
            testId="forgottenPasswordEmailContainer"
            placeholder={Constants.EMAIL}
            value={email.value}
            valid={email.valid}
            inputErrorMessage={email.error}
            id="email"
            loading={loading}
          />
        );
      case ForgottenPasswordFormStates.RESET_CODE:
        return (
          <ForgottenPasswordEnterCodeStep
            gotoSignIn={gotoSignIn}
            resetCode={resetCode.value}
            testId="forgottenPasswordResetCodeContainer"
            handleValueChange={handleValueChange}
            id="resetCode"
            onSubmit={gotoNextStep}
            resetInputs={resetCodeInputs}
            validating={resetCode.validating}
            error={resetCode.error}

          />
        );
      case ForgottenPasswordFormStates.RESET_PASSWORD:
        return <ForgottenPasswordEnterPasswordStep
          gotoSignIn={gotoSignIn}
          onSubmit={gotoNextStep}
          newPWErrorMessage={password.newPasswordError}
          confirmPWErrorMessage={password.newPasswordConfirmError}
          valid={password.valid}
          id="resetPassword"
          handleValueChange={handleValueChange}
          loading={loading}
        />;
      default:
        return null;
    }
  };

  const bgClass = "page full-screen";

  return (
    <React.Fragment>
      <Provider.Consumer
        render={(theme) => (
          <Flex
            className={
              theme.siteVariables.themeString === "default" ? 
              bgClass + " bg-onboarding default" : bgClass
            }
            data-testid="forgottenPasswordContainer"
          >
            <Form
              className="forgotten-password-form"
              data-testid="forgottenPasswordForm"
            >
              {renderStep()}
            </Form>
            {showErrorDialog ? (
              <ForgotPasswordErrorDialog
                onConfirm={onErrorConfirm} />)
              : null}
          </Flex>
        )}
      ></Provider.Consumer>
    </React.Fragment>
  );
};

ForgottenPasswordPageTemplate.propTypes = {
  currentStep: PropTypes.number.isRequired,
  gotoNextStep: PropTypes.func,
  gotoSignIn: PropTypes.func,
  username: PropTypes.object,
  handleValueChange: PropTypes.func,
  resetCodeInputs: PropTypes.func,
  resetCode: PropTypes.object,
  email: PropTypes.object,
  loading: PropTypes.bool,
  showErrorDialog: PropTypes.bool,
  onErrorConfirm: PropTypes.func,
  password: PropTypes.object,
};

export default ForgottenPasswordPageTemplate;
